import { adminTypes } from "@admin/admin-types.di";
import type { AdminRepository } from "@admin/domain/repositories/admin.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import { RecuperableModelError } from "@iot-platform/core";
import type {
    Station,
    StationUpdate,
} from "@station/domain/models/station.model";
import { inject, injectable } from "inversify";

@injectable()
export class StationUpdateUseCase {
    constructor(
        @inject(adminTypes.repositories.AdminRepository)
        private readonly adminRepository: AdminRepository,
    ) {}

    async execute(
        stationId: string,
        station: StationUpdate,
    ): Promise<Nullable<Station>> {
        const editResult = await this.adminRepository.updateStation(
            stationId,
            station,
        );

        return editResult.match(
            (stationEdited) => stationEdited,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return error.instance;
                }

                ToastManagerRepository.error(error.message);

                return null;
            },
        );
    }
}
